/**
 * Extracts plain text from URL-encoded HTML for copying
 */
export function extractPlainText(encodedHtml: string): string {
  try {
    let decoded = decodeURI(encodedHtml)
    let parsed = new DOMParser().parseFromString(decoded, 'text/html')
    return parsed.body.textContent || ''
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to extract plain text:', error)
    return encodedHtml
  }
}
